import ReactModal from "react-modal";
import { X } from "lucide-react";

ReactModal.setAppElement("#root");

const Modal = ({
  isOpen,
  onRequestClose,
  title,
  children,
  fullSize = false,
  maxWidthClass = "max-w-3xl",
  maxHeightClass = "max-h-[70vh]",
  customZIndex = 1001,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={title}
      overlayClassName="fixed inset-0 bg-black/60 flex justify-center items-end md:items-center backdrop-blur-md transition-all duration-300"
      style={{
        overlay: {
          zIndex: customZIndex,
        },
        content: {
          zIndex: customZIndex + 1,
        },
      }}
      className={`bg-white backdrop-blur-xl font-poppins dark:bg-gray-900/95 dark:backdrop-blur-xl border border-gray-200/50 dark:border-gray-700/50 shadow-2xl relative transition-all duration-500 transform ${
        fullSize
          ? "w-full h-full"
          : `w-full ${maxWidthClass} min-w-lg mx-4 md:mx-auto rounded-md`
      } ${
        isOpen
          ? "translate-y-0 opacity-100 scale-100"
          : "translate-y-full md:translate-y-0 opacity-0 scale-95"
      }`}
    >
      {/* Header with gradient background */}
      <div className="relative">
        <div className="absolute inset-0 "></div>
        <div className="relative flex items-center justify-between py-4 px-6">
          <div className="flex items-center space-x-3">
            {/* <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div> */}
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
              {title}
            </h2>
          </div>

          {/* Enhanced close button */}
          <button
            type="button"
            onClick={onRequestClose}
            className="group relative p-2 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95"
            aria-label="Close modal"
          >
            <X
              size={20}
              className="text-gray-600 transition-colors duration-200"
            />
            <div className="absolute inset-0 rounded-md transition-all duration-200"></div>
          </button>
        </div>
      </div>

      {/* Content area with custom scrollbar */}
      <div
        className={`relative overflow-y-auto ${
          fullSize ? "h-[calc(100%-5rem)]" : maxHeightClass
        } p-6`}
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "#cbd5e1 transparent",
        }}
      >
        {/* Custom scrollbar styles for webkit browsers */}
        <style jsx>{`
          div::-webkit-scrollbar {
            width: 6px;
          }
          div::-webkit-scrollbar-track {
            background: transparent;
          }
          div::-webkit-scrollbar-thumb {
            background: linear-gradient(to bottom, #cbd5e1, #94a3b8);
            border-radius: 3px;
          }
          div::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(to bottom, #94a3b8, #64748b);
          }
          .dark div::-webkit-scrollbar-thumb {
            background: linear-gradient(to bottom, #4b5563, #374151);
          }
          .dark div::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(to bottom, #6b7280, #4b5563);
          }
        `}</style>

        {/* Content wrapper with subtle animation */}
        <div className="animate-in fade-in-50 duration-500 delay-100">
          {children}
        </div>
      </div>

      {/* Subtle bottom border for visual separation */}
      {/* <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20 rounded-b-2xl"></div> */}
    </ReactModal>
  );
};

export default Modal;
